module.exports = __webpack_public_path__ + "e35cb18a9ca833ebe98bcb3af0ec1d73.svg";